<template>
  <v-app light>
    <v-content>
      <v-toolbar
        app
        :color="colors.button1"
        height="76"
      >
        <img
          class="icon-img"
          :src="logoImage"
          height="50px"
        />
        <span class="logo-name">I O R D E R</span>
      </v-toolbar>
      <v-container fluid>
        <transition
          name="page"
          mode="out-in"
        >
          <router-view />
        </transition>
      </v-container>
    </v-content>
    <full-loading />
    <feedback-message />
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import FeedbackMessage from '~/components/FeedbackMessage'
import FullLoading from '~/components/FullLoading'

export default {
  name: 'common-layout',
  components: {
    'feedback-message': FeedbackMessage,
    'full-loading': FullLoading
  },
  computed: {
    ...mapGetters('config', [
      'colors'
    ]),
    logoImage () {
      return window.config.sharedPictures + 'logo.png'
    }
  },
  mounted () {
    this.$bus.$emit('refreshFontName', 'proxima-nova')
  }
}
</script>

<style scoped>
.logo-name {
  font-size: 20px;
  font-weight: 800;
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/layouts/common.vue